import { Component, OnInit } from '@angular/core';
import { AuthAndACLService } from '../auth_and_acl/authAndACL.service';

@Component({
  selector: 'app-boas-vindas',
  templateUrl: './boas-vindas.component.html'
})
export class BoasVindasComponent implements OnInit {

  constructor(public authAndACL: AuthAndACLService,) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/boas-vindas/boas-vindas.component.ts